import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Barra superior com Logo - Fundo Branco */}
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo e Nome */}
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-3 group cursor-pointer">
                <div className="transform group-hover:scale-105 transition-all duration-300">
                  <img
                    src="/logo_ivox.svg"
                    alt="iVox Logo"
                    className="h-10 w-auto"
                  />
                </div>
                <div>
                  <span className="text-gray-800 font-bold text-xl tracking-wide">
                    Dashboard
                  </span>
                  <span className="block text-primary-600 text-xs font-medium -mt-0.5">
                    Analytics Platform
                  </span>
                </div>
              </div>
            </div>

            {/* Status e Logout */}
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2 text-sm text-gray-500">
                <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                <span>Online</span>
              </div>
              <button
                onClick={() => setShowLogoutConfirm(true)}
                className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                title="Sair"
              >
                <ArrowRightOnRectangleIcon className="w-5 h-5" />
                <span className="hidden sm:inline">Sair</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Barra de Navegação - Cor Primária */}
      <nav className="bg-gradient-to-r from-primary-500 to-primary-600">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center h-11">
            {/* Navigation Tabs */}
            <div className="flex">
              <button
                onClick={() => navigate('/')}
                className={`px-6 py-2.5 text-sm font-medium transition-all duration-200 border-b-2 ${
                  isActive('/')
                    ? 'bg-white/10 text-white border-white'
                    : 'text-white/80 border-transparent hover:text-white hover:bg-white/5'
                }`}
              >
                Dashboard Geral
              </button>
              <button
                onClick={() => navigate('/supervisor')}
                className={`px-6 py-2.5 text-sm font-medium transition-all duration-200 border-b-2 ${
                  isActive('/supervisor')
                    ? 'bg-white/10 text-white border-white'
                    : 'text-white/80 border-transparent hover:text-white hover:bg-white/5'
                }`}
              >
                Supervisor
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div>
        {children}
      </div>

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Confirmar saída</h3>
            <p className="text-gray-600 mb-6">Tem certeza que deseja sair do dashboard?</p>
            <div className="flex gap-3">
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={handleLogout}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                Sair
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Layout;
